// This given key is public
// https://stackoverflow.com/questions/37482366/is-it-safe-to-expose-firebase-apikey-to-the-public
// In order to secure it, please refer to
// https://stackoverflow.com/questions/35418143/how-to-restrict-firebase-data-modification

export const firebaseConfig =
{
  apiKey: "AIzaSyBDwp1H3BpLuWegV1drR6_e0r6TpQwOQsA",
  authDomain: "pc-firebase-auth-medium.firebaseapp.com",
  databaseURL: "https://pc-firebase-auth-medium.firebaseio.com",
  projectId: "pc-firebase-auth-medium",
  storageBucket: "pc-firebase-auth-medium.appspot.com",
  messagingSenderId: "531097980673",
  appId: "1:531097980673:web:467769a56adfcefac29500"
};

